var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/smallPlay.3458f6cf.png","uri@2x": __webpack_public_path__ + "static/media/smallPlay.db1978f6.png","uri@3x": __webpack_public_path__ + "static/media/smallPlay.79864d19.png",
    width: 24,
    height: 27
});